<div class="header">
	<ng-content select="[header]"></ng-content>
</div>
<div class="body" [style.background-color]="bodyColor">
	<ng-content select="[body]"></ng-content>
</div>
<div class="footer">
	<ng-content select="[footer]"></ng-content>
</div>
